import { render, staticRenderFns } from "./ForestersMasterclass1FR.vue?vue&type=template&id=5e879f4e&scoped=true"
import script from "./ForestersMasterclass1FR.vue?vue&type=script&lang=js"
export * from "./ForestersMasterclass1FR.vue?vue&type=script&lang=js"
import style0 from "./ForestersMasterclass1FR.vue?vue&type=style&index=0&id=5e879f4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e879f4e",
  null
  
)

export default component.exports